export default __webpack_public_path__ + "assets/Error-Generic-Blue-a49a6e5.png";